module.exports = __webpack_public_path__ + "img/hion_36.4a1bb21b.jpg";